// Simple animated skeleton placeholder
// Accepts width, height, and className props for flexibility
// Usage: <LoadingSkeleton width="80%" height={48} />
import React from 'react';

const LoadingSkeleton = ({ width = '100%', height = 20, className = '' }) => {
  const style = {
    width,
    height,
  };

  return (
    <div
      style={style}
      className={`animate-pulse rounded bg-gray-700/60 ${className}`.trim()}
    />
  );
};

export default LoadingSkeleton;
